module.exports = __webpack_public_path__ + "img/2.cfb0826f.jpg";